<template>
  <form @submit.prevent="saveUploadedUsers" :disabled="loading">
    <div
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{translate('userImport.importUsersFromExcel')}}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              :aria-label="translate('close')"
              @click="close()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="height:500px;overflow-x: hidden;overflow-y: scroll;">
              <div class="col-12">
                   <div class="dashboard-container">
                    <div class="info">
                      <p>
                      <strong>{{translate('externalSignerImport.warning')}}:</strong>
                      <span v-html="translate('userImport.text')"></span>
                      <br />
                      <strong>{{translate('targetSystemImport.notations')}}:</strong>
                      <br />
                      <span>Origin:</span> TC/Passport<br>
                      <span>MobileSignOperator:</span> Turkcell/Vodafone/TurkTelekom<br>
                      <span>Yetki Kolonları:</span> Admin({{translate('userImport.authorizedAll')}})	Approver({{translate('userImport.approver')}})	Signer({{translate('userImport.signer')}})	Draft({{translate('userImport.draftCreator')}})	CirculationProfile({{translate('userImport.circulationProfile')}})	Finalizer({{translate('userImport.finalizer')}})	Report({{translate('userImport.report')}})	Rem({{translate('userImport.rem')}})
                    <br>
                    {{translate('userImport.eForAuthorizedHforNo')}}

                      </p>
                  </div>
                  <div class="button_group">
                    <a
                      href="javascript:;"
                      class="button_s my_file el-button button_s el-button--primary el-button--small"
                    >
                          <div class="inline" style="display: flex;">

                      <input type="file" class="my_input form-control " @change="importExcel" id="upload" /> 
                    <label for="upload"  style="
                  border-radius: 0;
                  cursor: pointer;
                  text-decoration: none !important;" class="custom-file-upload"></label>
                          </div>
                    </a>
                  </div>
                </div>
              </div> 
          </div>
          <div class="modal-footer footer-button-container"> 
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click="close()"
              data-dismiss="modal"
            >
            {{translate('close')}}
            </button>
            <button  @click="saveUploadedUsers"  class="btn btn-primary">
              {{translate('save')}}
            </button>
            <button class="btn btn-info" @click="downloadTemplate()">{{translate('externalSignerImport.downloadSampleFile')}}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import formMixin from "../formMixin.js"; 


import xlsx from "xlsx";
export default {
  mixins: [formMixin],
  components: { 
  },
  created() {
      this.data = Object.assign({}, this.model);
  }, 
  props: {
        value : Object,
        model: Object,
    },
  data() {
    return {
      loading: false, 
      userList: [],
       userFile: [],
       errorMessage: ''
    };
  },
  methods: { 
    downloadTemplate(){
           window.open("../../Files/user_import_template.xlsx")
           
      },
     importExcel(e) {
      const files = e.target.files;
      console.log(files);
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert(this.translate('errors.uploadFormatIncorrectXLS'));
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          });
          const wsname = workbook.SheetNames[0]; 
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); 
          const excellist = []; 
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]); 
          }

          this.userList = excellist;
          this.prepareData();
          
          console.log("Read results111", Object.assign([],excellist));
          console.log("Read results", excellist); 
          } catch (e) {
          return alert(this.translate('errors.fileReadError'));
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
      input.value = "";

    },

prepareData(){
  this.userList.forEach(user => {
    if(user.BirthDate!= undefined && user.BirthDate != null){
      user.BirthDate = new Date(user.BirthDate)
    } 
      user.Admin = this.compareString(user.Admin);
      user.Approver = this.compareString(user.Approver);
      user.Signer = this.compareString(user.Signer)
      user.Draft =this.compareString(user.Draft); 
      user.CirculationProfile = this.compareString(user.CirculationProfile);
      user.Finalizer = this.compareString(user.Finalizer) 
      user.Report =this.compareString(user.Report) 
      user.Rem  = this.compareString(user.Rem);
      user.DepartmentManager = this.compareString(user.DepartmentManager);
      user.DraftCirculationCustomization = this.compareString(user.DraftCirculationCustomization);
      user.IncomingDocManager = this.compareString(user.IncomingDocManager);
  });
this.validate();
},

compareString(val){
  if(val != undefined || val != null || val == "" ){
    return false;
    }

  console.log(val)
  console.log(val.toLowerCase().localeCompare("e") == 0 ? true : false);
  return val.toLowerCase().localeCompare("e") == 0 ? true : false;
},

validate(){
axios.post('/user/ValidateUsers',this.userList)
.then((x) => {
          console.log("POST Result:", x.data);
          this.data = x.data;
        })
        .catch((x) => {
          this.errorMessage = this.translate('errors.processFailed') + x;
        })
        .then(() => {
          this.loading = false;
        });
},
  saveUploadedUsers(){ 
      this.$emit("onsave", this.userList);  

      },
       close(){
            this.$emit('close');
        }
  },
}
</script>



<style  scoped> 

.danger {
  background-color: #ffdddd;
  border-left: 6px solid #f44336;
}

.success {
  background-color: #ddffdd;
  border-left: 6px solid #4CAF50;
}

.info {
  padding: 20px;
  background-color: #e7f3fe;
  border-left: 6px solid #2196F3;
}


.warning {
  background-color: #ffffcc;
  border-left: 6px solid #ffeb3b;
}
input[type="file"] {
	display: inline-block;
	opacity: 0;
	position: absolute;
	margin-left: 20px;
	margin-right: 20px;
	padding-top: 30px;
	padding-bottom: 67px;
	width: 85%;
	z-index: 99;
	margin-top: 10px;
	cursor:pointer;
}
.custom-file-upload {
	position:relative;
    display: inline-block;
    cursor: pointer;
	padding-top:40px;
	padding-bottom:40px;
	background:url(../assets/uploadIcon.png) #fff center center no-repeat;
	width:91%;
	border:1px dashed #ff5b57 !important;
	margin-left:20px;
	margin-right:20px;
	margin-top:10px;
	text-align:center;
}

button { 
  padding: 8px;
  border-radius: 3px;
}

button:hover {
  background-color: #2196f3;
  color: white;
}
  .button_s {
    width: 78px;
    margin: 5px 10px 5px 5px;
  }
  .button_m {
    width: 100px;
    margin: 5px 10px 5px 5px;
  }
  .my_file {
    position: relative;
  }
    .my_input {
      /* position: absolute;
      opacity: 0;
      width: 78px;
      height: 30px;
      top: 0;
      left: 0; */
    }
   
</style>




 

 
